import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { IAccount } from './account';
import {
  fetchAccountsListToExport
} from './accountsToExport.thunks';

export interface AccountListState {
  accounts: IAccount[];
  loading: boolean;
  error: ApiError | null;
}

const initialState:AccountListState = {
  error: null,
  loading: false,
  accounts: []
};

const getAccountsToExportState = (state:RootState):AccountListState => state.accounts.accountsToExport;
const getError = (state:RootState):ApiError | null => getAccountsToExportState(state).error;
const getAccountToExport = (state:RootState):IAccount[] => getAccountsToExportState(state).accounts;
const getLoading = (state:RootState):boolean => getAccountsToExportState(state).loading;

export const selectors = {
  getError,
  getAccountToExport,
  getLoading
};

export const extraReducers = {
  [fetchAccountsListToExport.pending.type]: (state: AccountListState):void => {
    state.loading = true;
    state.accounts = [];
  },
  [fetchAccountsListToExport.fulfilled.type]: (state: AccountListState, action: AnyAction):void => {
    state.loading = false;
    state.accounts = action.payload.accounts;
  },
  [fetchAccountsListToExport.rejected.type]: (state: AccountListState, action: AnyAction):void => {
    state.loading = false;
    state.error = action.payload;
  }
};

export type UpdateTableQueryPayload = string;

const accountsToExportSlice = createSlice({
  name: 'accountsToExport',
  initialState,
  reducers: {},
  extraReducers
});

export default accountsToExportSlice.reducer;
export const actions = {
  ...accountsToExportSlice.actions,
  fetchAccountsListToExport
};
